import {FC} from "react";
import {Heading} from "../ui-components/heading.tsx";
import {Text} from "../ui-components/text.tsx";
import {Button} from "../ui-components/button.tsx";
import {useTranslation} from "react-i18next";

export const EmptySearchChannelResult:FC<{ title: string,subTitle:string, resetAll?:() => void }> = ({title, resetAll, subTitle}) => {

    const {t} = useTranslation();
    return (
        <div className={"h-full flex flex-col items-center gap-4 justify-center px-4"}>
            <Heading level={2} className={"!text-2xl text-[var(--text-color-dark)] font-semibold"}>
                {title}
            </Heading>
            <Text className={"!text-xs text-[var(--color-desc)] text-center leading-5 max-w-[400px]"}>
                {subTitle}
            </Text>
            <Button
                color={"white"}
                onClick={resetAll}
                className="w-full !bg-inherit !text-sm !font-semibold !py-[10px] rounded-lg !border !border-[var(--btn-border-custom)] shadow-xs"
            >
                {t('common.buttons.resetAll')}
            </Button>
        </div>
    )
}